import React from 'react'
import NancyHeroSplash from '../nancy-custom-ux-components/NancyHeroSplash';

export default function NancyDefaultPage() {
  return (
      <NancyHeroSplash />
  );
};
